import {defineStore} from 'pinia'
import {useCookie} from '#app'

export const useMemberStore = defineStore('member', {
  state: () => ({
    pathPrefix: '/member',
    accessToken: null,
    member: {
      id: 0,
      isAdmin: 0,
      name: '',
      userId: '',
      email: ''
    }
  }),
  getters: {
    isAuthenticated(state) {
      return !!state.accessToken
    },
    isAdmin(state) {
      return state.member.isAdmin === 1
    }
  },
  actions: {
    setAccessToken(accessToken) {
      this.accessToken = accessToken
    },
    setMember(member) {
      this.member = member
    },
    logout() {
      // 쿠키에서 토큰 삭제
      const tokenCookie = useCookie('access-token')
      tokenCookie.value = null
      this.accessToken = null
      this.member = {
        id: 0,
        isAdmin: 0,
        name: '',
        userId: '',
        email: ''
      }
    },
    /**
     * 회원가입
     * @param payload
     * @returns {Promise<void>}
     */
    async postMember(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    /**
     * 로그인
     * @param payload
     * @returns {Promise<void>}
     */
    async login(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/login`
      return await $apiClient(path, {
        method: 'POST',
        body: {
          userId: payload.userId,
          userPw: payload.userPw
        }
      })
    },
    /**
     * 회원 중복 체크
     * @param payload
     * @returns {Promise<void>}
     */
    async duplicateCheck(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/duplicate-check`
      return await $apiClient(path, {
        method: 'POST',
        body: {
          userId: payload
        }
      })
    },
    async postMemberAddress(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/address`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async getMemberInfo() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getMemberApplicationList() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/application`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getMemberSubscribeList() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/subscribe`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getMemberMain() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/my`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getMemberDownloadHistoryList(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/download/history`
      const query = `?page=${payload.page}&limit=${payload.limit}`
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    },
    async getMemberDeliveryList(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/delivery`
      const query = `?page=${payload.page}&limit=${payload.limit}`
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    },
    async getMemberAddressList() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/address`
      return await $apiClient(path, {
        method: 'GET'
      })
    },

    async getMySeminarApplicationDetail(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/application/${payload.applicationId}?type=${payload.type}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async putMemberInfo(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}`
      return await $apiClient(path, {
        method: 'PUT',
        body: payload
      })
    },
    async putMemberApplicationDetail(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/application/${payload.applicationId}`
      return await $apiClient(path, {
        method: 'PUT',
        body: {
          type: payload.type,
          participant: payload.participant,
        }
      })
    },
    async putMemberAddress(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/address/${payload.addressId}`
      return await $apiClient(path, {
        method: 'PUT',
        body: payload.addressList
      })
    },
    async deleteMember() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}`
      return await $apiClient(path, {
        method: 'DELETE'
      })
    },
    async postFindUserId(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/find/id`
      return await $apiClient(path, {
        method: 'POST',
        body: {name: payload.name, email: payload.email}
      })
    },
    async postFindUserPw(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/find/pw`
      return await $apiClient(path, {
        method: 'POST',
        body: {userId: payload.userId, email: payload.email}
      })
    }
  }
})
